import React, { useState } from "react";
import { useCookies } from "react-cookie";
import "animate.css";

const CookieBanner = () => {
  const [cookies, setCookie] = useCookies(["cookieConsent"]);
  const [isVisible, setIsVisible] = useState(!cookies.cookieConsent);

  const acceptCookies = () => {
    setCookie("cookieConsent", true, { path: "/", maxAge: 31536000 });
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="banner bg-brown animate__animated animate__slideInRight">
      <p className="fs-12 text-start mt-3 ">
        We use cookies to improve your experience. By continuing, you agree to
        our use of cookies.
      </p>
      <div className="d-flex flex-column">
        <button onClick={acceptCookies} className="btn btn-light btn-sm rounded-5 px-4 mb-3">
          Accept
        </button>
        <a href="/cookies-policy" onClick={acceptCookies} className="btn btn-light btn-sm rounded-5 px-4">
          Cookies
        </a>
      </div>
    </div>
  );
};

export default CookieBanner;
